module.exports = __webpack_public_path__ + "img/bazarLight.2a829e84.svg";